
import { defineComponent, PropType, ref, computed } from 'vue'
import ConfirmInput from '@/components/organisms/dms/common/ConfirmInput.vue'
import { AutoCollectOnlineData } from '@/data/dms/dmsData'

export default defineComponent({
  name: 'ItemConfirm',
  components: {
    ConfirmInput
  },
  props: {
    modelValue: {
      type: Object as PropType<AutoCollectOnlineData>
    }
  },
  setup (props, { emit }) {
    const state = computed({
      get: () => props.modelValue,
      set: (state) =>
        emit('update:modelValue', state)
    })
    return {
      props,
      state
    }
  }
})
